import React, {useState} from 'react';
import PropTypes from 'prop-types'
import FormInput from "../Templates/FormInput";
import Icon from "../Icon";

const PasswordInput = ({className, label}) => {
  const [showPassword, setShowPassword] = useState(false)
  const toggleShowPassword = () => setShowPassword(!showPassword)

  return (
    <div className={`s-relative ${className}`}>
      <FormInput
        label={label || 'Contraseña'}
        id="login-password"
        name="password"
        type={showPassword ? 'text' : 'password'}
        placeholder="••••••••••"
      />
      <Icon
        onClick={toggleShowPassword}
        svg={showPassword ? 'eye-off' : 'eye'}
        className="s-absolute s-right-16px s-bottom-10px cursor-pointer"/>
    </div>
  );
};

PasswordInput.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
}

export default PasswordInput;
